import(/* webpackMode: "eager" */ "/vercel/path0/ui/app/memo-archive/page.tsx");
